var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDryVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.1 68.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.6,47c-5.6,0-10.1,4.5-10,10,0,5.5,4.5,10,10,10s10-4.5,10-10-4.5-9.9-10-10ZM65.6,62.9c-3.3,0-6-2.7-6-6s2.7-5.9,5.9-6c3.3,0,6,2.6,6,5.9s-2.6,6.1-5.9,6.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.6,47c-5.5,0-10,4.4-10,9.8s4.3,10.2,9.9,10.2,10-4.4,10-10-4.4-10-9.9-10ZM37.6,57c0-3.3,2.6-5.9,5.9-6,3.3,0,6,2.6,6,6s-2.6,6-6,6-5.9-2.6-5.9-5.9h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.9,61c3.1,0,4.8-.8,6.1-2.6.3-.4.5-.7.5-1.3v-7.3c0-.7-.2-.9-.9-.9h-7.3c-1.1,0-1.8-.3-1.8-1.5s-.2-.5-.6-.5h-1.3c-.7,0-1.6-.4-2.1.3s.2,2.6.8,3.4c1.5,2,3.4,2.7,5.8,2.4.9,0,1.8,0,2.8,0s.7.2.7.7v1.6c0,1.3-.4,1.7-1.7,1.7h-7.4c-.7,0-.9.2-.9.9q0,3.2,3.1,3.2h4.3-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.6,1H4.7c-1.6,0-3,1.5-3,3.1v37.9c0,1.5,1.5,3,3,3h6.5v11.5c-.5.2-.9.7-.9,1.3v.4c0,.8.7,1.5,1.5,1.5h3.9c.8,0,1.5-.7,1.5-1.5v-.4c0-.6-.3-1-.8-1.3,0,0,0,0,0,0v-11.6h76c1.8,0,3.2-1.4,3.2-3.2V4c0-1.5-1.5-3-3-3ZM92,40c0,1.1-.3,1.3-1.3,1.3H7.4c-1.1,0-1.4-.3-1.4-1.4V6.4c0-.9.2-1.2,1.2-1.2h83.6c1,0,1.2.3,1.2,1.2v33.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryVan);
export default __webpack_public_path__ + "static/media/dry-van.49cb95f4bc41abd99a5a501064cd72cb.svg";
export { ForwardRef as ReactComponent };